// Aspect utilities for module instance aspect rolling

export type ElementType = 'THERMAL' | 'CRYO' | 'RADIATION' | 'EMP' | 'VOID';

export const ALL_ASPECTS: ElementType[] = ['THERMAL', 'CRYO', 'RADIATION', 'EMP', 'VOID'];

/**
 * Roll random aspects based on module rarity
 * - Common: 1 random aspect
 * - Rare: 60% chance 1 aspect, 40% chance 2 aspects
 * - Officer: Always 2 aspects
 */
export function rollAspectsForRarity(rarity: 'common' | 'rare' | 'officer'): string[] {
    const shuffled = [...ALL_ASPECTS].sort(() => Math.random() - 0.5);

    switch (rarity) {
        case 'common':
            return [shuffled[0]];
        case 'rare':
            // 60% chance for 1 aspect, 40% chance for 2
            return Math.random() < 0.6 ? [shuffled[0]] : [shuffled[0], shuffled[1]];
        case 'officer':
            return [shuffled[0], shuffled[1]];
        default:
            return [shuffled[0]];
    }
}

/**
 * Roll additional aspects for evolution (preserves existing, adds new if needed)
 * Used when evolving to a higher rarity that requires more aspects
 */
export function rollAdditionalAspect(existingAspects: string[]): string[] {
    const available = ALL_ASPECTS.filter(a => !existingAspects.includes(a));
    if (available.length === 0) {
        return [...existingAspects];
    }
    const newAspect = available[Math.floor(Math.random() * available.length)];
    return [...existingAspects, newAspect];
}

/**
 * Determine required number of aspects for a rarity
 */
export function getMinAspectsForRarity(rarity: 'common' | 'rare' | 'officer'): number {
    switch (rarity) {
        case 'common': return 1;
        case 'rare': return 1; // Rare can have 1 or 2
        case 'officer': return 2;
        default: return 1;
    }
}

// Map aspect to orb color for charge sources
export const ASPECT_TO_ORB: Record<string, string> = {
    THERMAL: 'R',
    CRYO: 'B',
    RADIATION: 'G',
    EMP: 'Y',
    VOID: 'P',
};
